import { find, isEmpty, toLower } from 'lodash';
import { LanguagePicker } from '../../components/LanguagePicker';
import { useStore } from '../../store';

export const LanguageSelectionGate = ({ children }: { children: JSX.Element }) => {
    const selectedLanguage = useStore((state) => state.selectedLanguage);
    const languages = useStore((state) => state.languages);
    const selectedLanguageIsSupported = find(
        languages,
        (lang) => toLower(lang) === toLower(selectedLanguage || ''),
    );
    return (
        <>
            {children}
            <LanguagePicker opened={isEmpty(selectedLanguageIsSupported)} />
        </>
    );
};
